@if (control) {
  <astral-field-shell [control]="control" [forId]="resolvedInputId" [helpText]="helpText">
    <div
      class="autocomplete-remote"
      [class.autocomplete-remote--readonly]="control?.isReadonly"
      [class.autocomplete-remote--disabled]="control?.disabled"
      [class.autocomplete-remote--focused]="isFocused"
      >
      <div class="autocomplete-remote__actions">
        @if (showClearOthers) {
          <astral-field-action
            icon="clearOthers"
            titleKey="COMMON.CLEAR_OTHER_FILTERS"
            ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
            (click)="addonClicked()"
          ></astral-field-action>
        }
        @if (showClearThis) {
          <astral-field-action
            icon="clear"
            titleKey="COMMON.CLEAR"
            ariaLabelKey="COMMON.CLEAR"
            (click)="clearBtnClicked()"
          ></astral-field-action>
        }
      </div>
      <div cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin" #controlShell class="autocomplete-remote__control-shell">
        <input
          #input
          class="autocomplete-remote__control"
          type="text"
          autocomplete="off"
          [attr.id]="resolvedInputId"
          [attr.name]="resolvedInputName"
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-controls]="panelId"
          [attr.aria-expanded]="isPanelOpen"
          [attr.aria-activedescendant]="activeOptionId"
          astralFieldAccessibility
          [astralFieldControl]="control"
          [astralFieldHelpText]="helpText"
          [astralFieldInputId]="resolvedInputId"
          [attr.placeholder]="'COMMON.TYPE_TO_SEARCH' | translate"
          [formControl]="selectionControl"
          [required]="control.required ? true : null"
          [readonly]="control.isReadonly ? true : null"
          (blur)="handleBlur()"
          (focus)="handleFocus()"
          (input)="handleInput()"
          (keydown)="handleKeydown($event)"
          />
        </div>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="overlayOrigin"
          [cdkConnectedOverlayOpen]="isPanelOpen && (!!itemsSource?.length || noItems)"
          [cdkConnectedOverlayPositions]="overlayPositions"
          [cdkConnectedOverlayWidth]="overlayWidth"
          [cdkConnectedOverlayPush]="false"
          [cdkConnectedOverlayFlexibleDimensions]="true"
          [cdkConnectedOverlayViewportMargin]="overlayViewportMargin"
          (overlayOutsideClick)="handleOverlayOutsideClick($event)"
          (positionChange)="handleOverlayPositionChange($event)"
          >
          <div
            class="autocomplete-remote__panel"
            [attr.id]="panelId"
            [class.autocomplete-remote__panel--above]="isPanelAbove"
            role="listbox"
            [attr.aria-labelledby]="resolvedInputId"
            >
            @for (item of itemsSource; track item; let i = $index) {
              <button
                #optionElement
                type="button"
                class="autocomplete-remote__option"
                role="option"
                tabindex="-1"
                [attr.id]="resolvedInputId + '-option-' + i"
                [attr.aria-selected]="control?.value === item.value"
                [class.autocomplete-remote__option--active]="activeOptionIndex === i"
                (mousedown)="handleOptionMouseDown($event)"
                (click)="selectItem(item)"
                >
                {{ item.name }}
              </button>
            }
            @if (noItems) {
              <div class="autocomplete-remote__empty">
                {{ 'COMMON.SEARCH_RESULT_EMPTY' | translate }}
              </div>
            }
          </div>
        </ng-template>
      </div>
    </astral-field-shell>
  }
